<template>
  <div class="execute-vm">
    <InfoBox>
      <div>
        Write the connection information of the device or server you would like
        to configure using this playbook.
      </div>
    </InfoBox>

    <b-form-group label="Select Virtual Machine">
      <multiselect
        id="vm-list-selectbox"
        v-model="form.vm"
        :options="vmList"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        placeholder="Select Virtual Machine"
        :loading="loading"
        :custom-label="customVMListLabel"
        @search-change="getVMList"
        :limit="3"
        :show-no-results="false"
        :state="validateState('vm')"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ExecuteVM',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
  },
  data() {
    return {
      loading: false,
      form: {
        vm: '',
      },
      vmList: [],
    }
  },
  validations: {
    form: {
      vm: {
        required,
      },
    },
  },
  created() {
    this.getVMList('')
  },
  methods: {
    getVMList(search) {
      this.loading = true

      if (search != '') {
        this.vmList = []
      }

      this.getVMs(search)
        .then((res) => {
          this.setVMList(res)
          this.loading = false
        })
        .catch(() => {
          this.vmList = []
        })
    },
    getVMs(search) {
      return new Promise((resolve, reject) => {
        let query = `iaas/virtual-machines?position=id|desc`

        if (search && search != '') {
          query += `&name=${search}`
        }

        ApiService.get(query)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    setVMList(res) {
      this.vmList = res.data
    },
    customVMListLabel({ name }) {
      return `${name}`
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        host:
          this.form.vm.connectionParameters.data.length > 0
            ? this.form.vm.connectionParameters.data[0].ip_addr
            : null,
        host_user: this.form.vm.username,
        host_pass: this.form.vm.password,
        become: 1,
        port:
          this.form.vm.connectionParameters.data.length > 0
            ? this.form.vm.connectionParameters.data[0].port
            : null,
      }

      ApiService.post(
        `ansible/playbook/${this.$route.params.id}/execute`,
        params
      )
        .then(() => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', true)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>

<style lang="scss">
.execute-vm .info {
  font-size: 13px;
  color: #b5b5c3;
  margin-bottom: 20px;
}
</style>
